<div class="d-flex justify-content-between gap-3 align-items-center">

  <div class="d-flex gap-3 align-items-center justify-content-center">
    <a id="btn-collapse" class="sidebar-collapser">
      <img src="../../../assets/Krid/img/toggle-icon.svg" alt="" />
    </a>
    <h5 class="cnter"><b>{{ companyName || "" }}</b></h5>
  </div>
@if (currentRoute.includes("claim-workflow") ||currentRoute.includes("upload")  ) {
  <div class="info-icon">
    <mat-form-field class="company-dropdown-background" *ngIf="roleId === '1'" >
      <mat-select class="me-2" placeholder="Select company" panelClass="company-select-panel"
        (selectionChange)="onCompanyChange($event)" [(ngModel)]="companyId">
        <mat-option>
          <ngx-mat-select-search placeholderLabel="Search company" [(ngModel)]="searchControl"
            (ngModelChange)="filterCompanies(searchControl)" noEntriesFoundLabel="No company found.">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of filteredCompanyList" [value]="item.id" [title]="item.companyName">
          {{ item.companyName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="claim-year-dropdown-background">
      <mat-select class="me-2" placeholder="Select claim year" panelClass="claim-select-panel"
        (selectionChange)="onYearChange($event)" [(ngModel)]="yearId">
        <mat-option>
          <ngx-mat-select-search placeholderLabel="Search claim year" [(ngModel)]="searchYearControl"
            (ngModelChange)="filterYear(searchYearControl)"
            noEntriesFoundLabel="No claim year found."></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of filteredYearList" [value]="item.id" [title]="item.displayLabel">
          {{ item.displayLabel }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button type="button" class="btn btn-primary-datalist me-2" (click)="resetCompanyFilter()">
      <i class="fa fa-refresh"></i>
    </button>

  </div>

}

</div>
